import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DevChannelComponent = () => {
  const [devChannels, setDevChannels] = useState([]);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [backgroundColor, setBackgroundColor] = useState('#ffffff');
  const [textColor, setTextColor] = useState('#000000');
  const [type, setType] = useState('');
  const [channelStartDate, setChannelStartDate] = useState('');
  const [channelEndDate, setChannelEndDate] = useState('');
  const [editingId, setEditingId] = useState(null);

  // Fetch all devChannels on component mount
  useEffect(() => {
    fetchDevChannels();
  }, []);

  const fetchDevChannels = async () => {
    try {
      const response = await axios.get('/api/devChannels');
      setDevChannels(response.data);
    } catch (error) {
      console.error('Error fetching devChannels:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      name,
      description,
      backgroundColor,
      textColor,
      type,
      channelStartDate,
      channelEndDate,
    };

    try {
      if (editingId) {
        // Update existing devChannel
        await axios.put(`/api/devChannels/${editingId}`, data);
        setEditingId(null);
      } else {
        // Create new devChannel
        await axios.post('/api/devChannels', data);
      }
      fetchDevChannels();
      // Reset form fields
      setName('');
      setDescription('');
      setBackgroundColor('#ffffff');
      setTextColor('#000000');
      setType('');
      setChannelStartDate('');
      setChannelEndDate('');
    } catch (error) {
      console.error('Error saving devChannel:', error);
    }
  };

  const handleEdit = (channel) => {
    setName(channel.name);
    setDescription(channel.description);
    setBackgroundColor(channel.backgroundColor || '#ffffff');
    setTextColor(channel.textColor || '#000000');
    setType(channel.type || '');
    setChannelStartDate(channel.channelStartDate || '');
    setChannelEndDate(channel.channelEndDate || '');
    setEditingId(channel._id);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/devChannels/${id}`);
      fetchDevChannels();
    } catch (error) {
      console.error('Error deleting devChannel:', error);
    }
  };

  return (
    <div>
      <h2>DevChannels</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <input
          type="text"
          placeholder="Type"
          value={type}
          onChange={(e) => setType(e.target.value)}
        />
        <label>
          Background Color:
          <input
            type="color"
            value={backgroundColor}
            onChange={(e) => setBackgroundColor(e.target.value)}
          />
        </label>
        <label>
          Text Color:
          <input
            type="color"
            value={textColor}
            onChange={(e) => setTextColor(e.target.value)}
          />
        </label>
        <label>
          Start Date:
          <input
            type="date"
            value={channelStartDate}
            onChange={(e) => setChannelStartDate(e.target.value)}
          />
        </label>
        <label>
          End Date:
          <input
            type="date"
            value={channelEndDate}
            onChange={(e) => setChannelEndDate(e.target.value)}
          />
        </label>
        <button type="submit">{editingId ? 'Update' : 'Create'}</button>
      </form>
      <ul>
        {devChannels.map((channel) => (
          <li key={channel._id}>
            <strong>{channel.name}</strong> - {channel.description} - Type: {channel.type}
            <br />
            Background Color: <span style={{ backgroundColor: channel.backgroundColor }}>{channel.backgroundColor}</span>
            <br />
            Text Color: <span style={{ color: channel.textColor }}>{channel.textColor}</span>
            <br />
            Start Date: {channel.channelStartDate}
            <br />
            End Date: {channel.channelEndDate}
            <button onClick={() => handleEdit(channel)}>Edit</button>
            <button onClick={() => handleDelete(channel._id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DevChannelComponent;
